import { baseSetting } from '@/api/index'

export function selectpackpagesbysite (data: any) {
  return baseSetting.request({
    method: 'post',
    url: '/selectpackpagesbysite',
    data
  })
}
export function deleteProductcode (data: any) {
  return baseSetting.request({
    method: 'post',
    url: '/deleteProductcode',
    data
  })
}
export function addProductcode (data: any) {
  return baseSetting.request({
    method: 'post',
    url: '/addProductcode',
    data
  })
}
export function selectProductcode (data: any) {
  return baseSetting.request({
    method: 'post',
    url: '/selectProductcode',
    data
  })
}
export function selectWeightgesetupbysite (data: any) {
  return baseSetting.request({
    method: 'post',
    url: '/selectWeightgesetupbysite',
    data
  })
}
export function selectVolumgesetupbysite (data: any) {
  return baseSetting.request({
    method: 'post',
    url: '/selectVolumgesetupbysite',
    data
  })
}
